module.exports = __webpack_public_path__ + "img/bg_member_activity.6ff698a0.png";